import React from 'react';
import { PermissiosAccordion } from './permission-accordion';
import PermissionCheckbox from './PermissionCheckbox';
import { ApiPermissions } from '../../../../core';
import CheckBox from '../../../../components/check-box';

interface EntityPermissionsProps {
  entity: {
    entity: string;
    permissions: ApiPermissions[];
  };
  onPermissionSelection?: (
    permission: string | string[],
    selected: boolean
  ) => void;
  disabled?: boolean;
}

const EntityPermissions: React.SFC<EntityPermissionsProps> = (props) => {
  const { entity, onPermissionSelection } = props;
  if (!entity) {
    return <></>;
  }
  const { permissions } = entity;
  const allSelected = !permissions.find((per) => !per.selected);
  const permissionCount = permissions.filter((per) => per.selected).length;

  const subHeading = allSelected
    ? 'All permissions granted'
    : `${permissionCount || 'No'} permission${
        permissionCount === 1 ? '' : 's'
      } granted`;

  const header = (
    <CheckBox
      id={`selec_all_${entity.entity}_permissions`}
      label=""
      checked={allSelected}
      // containerStyles={{ bottom: '7px', right: '-6px' }}
      onChange={(val) => {
        if (onPermissionSelection) {
          onPermissionSelection(
            permissions.map((per) => per.permission),
            val
          );
        }
      }}
      disabled={props.disabled}
      labelClassName="font-normal font-weight-semibold text-gray-800"
    />
  );
  return (
    <PermissiosAccordion
      header={header}
      heading={`${entity.entity.replace(/_/g, ' ')}`}
      subHeading={subHeading}
      headingLevel="sm"
      withBorder={true}
      innerClass="timeline-collapse"
    >
      {permissions &&
        permissions.map((permission) => {
          return (
            <PermissionCheckbox
              permission={permission}
              onSelection={onPermissionSelection}
              disabled={props.disabled}
            />
          );
        })}
    </PermissiosAccordion>
  );
};

export default EntityPermissions;
